import React from "react";
import { LineBreak, Title } from "./Title";
import { picture, sideScroll } from "./look";

export default function SquareSections({ block }) {
  return block.rows.map((section) => (
    <div key={section.id}>
      <LineBreak />
      <Title name={section.title} icon={section.logo} />
      <div style={{ ...sideScroll, gap: 10, padding: "0 10px", marginBottom: 30 }}>
        {section.banners.map((banner) => (
          <img key={banner.id} src={picture(banner.image)} alt=""
            style={{ flex: "0 0 160px", height: 160, objectFit: "cover", borderRadius: 5, background: "#E6E6E6" }} />
        ))}
      </div>
    </div>
  ));
}
